module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("Notifications", "Delete notifications") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc( "Notifications", "Are you sure you want to delete all notifications?" ) ))==null?'':__t)+
'</p><p class="error" data-text="delete-all-notifications-error"></p></fieldset><fieldset class="button-wrap"><button data-click="notifications-delete-cancel">'+
((__t=( i18n.tc("Notifications", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="notifications-delete-submit">'+
((__t=( i18n.tc("Notifications", "Delete") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
